<template>
  <div>
    <hg-dialog title="新增系统" :width="500" :height="300" :visible.sync="dialogVisible" @close="handleClose">
      <el-form :model="data"  size="mini" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="系统名称" prop="name">
          <el-input v-model="data.name" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="路径" prop="path">
          <el-input v-model="data.path"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="data.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="hg-dialog-footer">
         <el-button type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
      </span>
    </hg-dialog>
  </div>
</template>
<script>
import HgDialog from '@/components/dialog';

export default {
  name: 'add',
  components: { HgDialog },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        name: [{
          required: true,
          message: '请输入系统名称',
          trigger: 'blur'
        }],
        path: [{
          required: true,
          message: '请输入路径',
          trigger: 'blur'
        }]
      },
      data: {
        name: '',
        path: '',
        remark: '',
        updateFlg: 'add'
      }
    };
  },
  methods: {
    submit() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.addSystem();
        }
        else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    async addSystem() {
      const res = await this.$services.postJson({
        type: 'SYSTEMOPERATION',
        url: 'saveSystem',
        params: JSON.parse(JSON.stringify(this.data))
      });
      if (res.code === '000') {
        this.$toaster.ok('保存成功');
        this.handleClose();
        this.$emit('refresh');
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    handleClose(type) {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.$emit('close');
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
      }
    }
  }
};
</script>
